import { Component } from 'react';
import TrackGoogleDiscoverResultsAdd from '../../TrackGoogleDiscoverResultsAdd';

class TrackGoogleDiscover extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <TrackGoogleDiscoverResultsAdd
                csrf_token={this.props.csrf_token}
                default_image={this.props.default_image}
                defaultDisabled={this.props.tracking_entity}
                fromOnboard
                handleBack={this.props.handleBack}
                handleNext={this.props.handleNext}
            />
        );
    }
}

export default TrackGoogleDiscover;
